import React, { useEffect } from "react";
import { ServicesCard } from "../../component/common/Card/ServicesCard/ServicesCard";
import {
  CircularProgress,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import "./index.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getImageUrl } from "../../utils/imageUrl";
import { get_services } from "../../services/services";
import { asyncStatus } from "../../utils/asyncStatus";
import { themeOrange } from "../../utils/colorTheme";
import { setJobsSteps } from "../../store/slices/ui_control_slice";
import { setJobsImages } from "../../store/slices/services_slice";
import { service_booking_keys, steps_constants } from "../../store/constants";

const SecondSection = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { get_all_services_status, get_all_services_data } = useSelector(
    (state) => state.serviceManage
  );

  console.log("get_all_services_data: ", get_all_services_data);

  const storedUserRoleString = +localStorage.getItem("user_role");

  console.log("storedUserRoleString: ", storedUserRoleString);

  const getServiceLoader = get_all_services_status === asyncStatus.LOADING;

  const _handleClick = (item) => {
    navigate(`/service-details/${item}`);
    dispatch(setJobsSteps({ value: null }));
    localStorage.removeItem(steps_constants.JOBS_STEP);
    localStorage.removeItem(service_booking_keys.DATE);
    localStorage.removeItem(service_booking_keys.TIME);
    localStorage.removeItem(service_booking_keys.DESCRIPTION);
    localStorage.removeItem(service_booking_keys.LOCATION);
    localStorage.removeItem(service_booking_keys.PRICE);
    localStorage.removeItem(service_booking_keys.IMAGES);
  };

  useEffect(() => {
    // Only fetch services if not already loaded to prevent rate limiting
    if (!get_all_services_data) {
      dispatch(get_services());
    }
  }, [dispatch, get_all_services_data]);

  return (
    <div className="main-container-second-section">
      <Container maxWidth="xl" sx={{ px: { xs: 1.5, sm: 5, md: 8, lg: 12, xl: 16 } }}>
        <Typography className="second-section-heading">
          <span style={{ color: "#F15A24" }}>Services</span>
        </Typography>
        <div className="card-main-container">
          {getServiceLoader ? (
            <Stack
              alignItems={"center"}
              justifyContent={"center"}
              sx={{ width: "100%", height: "20vh" }}
            >
              <CircularProgress size={30} sx={{ color: themeOrange }} />
            </Stack>
          ) : (
            <Grid
              container
              spacing={{ xs: 1.5, sm: 2, md: 2.5, lg: 2.5, xl: 2.5 }}
              justifyContent={"center"}
              sx={{ p: { xs: 1, sm: 2, md: 2, lg: 3, xl: 3 } }}
            >
              {get_all_services_data?.services?.map((e, i) => {
                return (
                  <Grid item xl={2} lg={2} md={2} sm={4} xs={6}>
                    <ServicesCard
                      key={i}
                      src={getImageUrl(e?.image)}
                      heading={e.name}
                      onClick={() => _handleClick(e.slug)}
                    />
                  </Grid>
                );
              })}
            </Grid>
          )}
        </div>
      </Container>
    </div>
  );
};

export default SecondSection;
